var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.6473 15.0072H15.9336C15.9336 19.4872 15.9336 25 15.9336 25H11.9115C11.9115 25 11.9115 19.54 11.9115 15.0072H10V11.4757H11.9115V9.19285C11.9115 7.55571 12.6639 5 15.971 5L18.9516 5.01142V8.44001C18.9516 8.44001 17.1397 8.44001 16.7884 8.44001C16.4357 8.44001 15.935 8.62142 15.935 9.40142V11.4771H19L18.6473 15.0072Z","fill":"#424B5A","key":0}),React.createElement("circle",{"cx":"15","cy":"15","r":"14.75","stroke":"#616161","strokeWidth":"0.5","key":1})]);
}

FacebookIcon.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
